module.exports = __webpack_public_path__ + "img/138.56cdba63.jpg";